// routes/userRoutes.js
import { lazy } from 'react';

// Lazy load the User pages
const UserProfile = lazy(() => import('../pages/user/UserProfile'));
const UserSettings = lazy(() => import('../pages/user/UserSettings'));

export const userRoutes = [
  { path: '/user/profile', element: <UserProfile /> },
  { path: '/user/settings', element: <UserSettings /> },
];
